<div
  [ngClass]="{
    'bg-[#FFFFFF] h-[calc(100vh-145px)] rounded-xl border hover:shadow-xl flex flex-col overflow-hidden':
      showCard,
    'bg-transparent': !showCard
  }"
>
  @if (showPagination || showSearch || showFilters) {
  <div class="relative flex flex-wrap items-start justify-between gap-2 py-2 px-4 shrink-0">
    @if (showPagination) {
    <div
      class="flex flex-col sm:flex-row sm:items-center sm:space-x-2 text-[#717784] text-[13px] md:text-[14px]"
    >
      <div class="flex items-center space-x-2 mb-2 sm:mb-0">
        <label for="entries">Show</label>
        <select
          id="entries"
          [ngModel]="serverSidePagination ? serverPageSize : selectedEntries"
          (ngModelChange)="handlePageSizeChange($event)"
          class="border border-gray-300 rounded-md px-2 text-[12px] md:text-[13px] py-1 focus:outline-none"
        >
          @for (entry of entries; track entry) {
          <option [value]="entry">
            {{ entry }}
          </option>
          }
        </select>
        <span>Entries</span>
      </div>
      <div class="flex flex-wrap items-center gap-2 sm:px-1.5">
        <!-- Total Pages Info -->
        <div
          class="flex items-center space-x-2 pr-2 text-[#717784] text-[13px] md:text-[14px] whitespace-nowrap"
        >
          <span>Total Records:</span>
          <span class="font-medium text-[#717784]">{{ getTotalRecords() }}</span>
        </div>

        <div class="flex items-center flex-wrap gap-2">
          <!-- Previous Button -->
          <button
            (click)="
              changePage(
                (serverSidePagination ? serverCurrentPage : currentPage) - 1
              )
            "
            [disabled]="
              (serverSidePagination ? serverCurrentPage : currentPage) === 1
            "
            class="md:px-2.5 px-1 py-[4px] border border-[#DBE0E6] bg-[#F6F8FC] text-[#25282D] rounded-md text-[12px] md:text-[13px] hover:bg-gray-100 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 19l-7-7 7-7"
              />
            </svg>
            <span class="max-lg:hidden">Prev</span>
          </button>

          <!-- Page Indicator -->
          <span
            class="px-2.5 py-[4px] rounded-md bg-[#F6F8FC] text-[#25282D] text-[12px] md:text-[13px] font-medium text-nowrap"
          >
            Page {{ serverSidePagination ? serverCurrentPage : currentPage }} of
            {{ totalPages() }}
          </span>

          <!-- Next Button -->
          <button
            (click)="
              changePage(
                (serverSidePagination ? serverCurrentPage : currentPage) + 1
              )
            "
            [disabled]="
              (serverSidePagination ? serverCurrentPage : currentPage) ===
              totalPages()
            "
            class="md:px-2.5 pr-1 py-[4px] border border-[#DBE0E6] bg-[#F6F8FC] text-[#25282D] rounded-md text-[12px] md:text-[13px] hover:bg-gray-100 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1"
          >
            <span class="max-lg:hidden">Next</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    }

    <div class="flex gap-1.5 flex-none w-full sm:w-auto md:justify-end">
      @if (showSearch) {
      <app-search
        class="lg:w-44 w-40 max-w-full flex items-center"
        [value]="searchValue"
        (searchChange)="onSearchChange($event)"
      />
      } @if (showFilters) {
      <!-- Filter Component Slot - Parent provides filter component here -->
      <div class="flex items-center">
        <ng-content select="[filterSlot]"></ng-content>
      </div>
      }
    </div>
  </div>
  }

  <!-- Single scrollable container for both header and body -->
  <div
    #tableContainer
    class="relative overflow-x-auto overflow-y-auto"
    [ngClass]="{
      'flex-1 min-h-0': showCard,
      'max-h-[80vh]': !showCard && !tableContainerFullHeight,
      'h-screen': tableContainerFullHeight
    }"
  >
    <!-- Table with auto layout -->
    <table #headerTable class="border-collapse w-full min-w-max">
      <thead class="bg-gray-100">
        <tr>
          @for (column of visibleColumns; track column.key; let i = $index) {
          <th
            class="px-4 py-2.5 font-normal text-sm bg-gray-100 sticky top-0 z-10 whitespace-nowrap"
            [ngClass]="{
              'cursor-pointer hover:bg-gray-200':
                column.key !== 'menu' && column.key !== 'expand' && column.key !== '' && (column.sortable !== false),
              'cursor-default': column.key === 'menu' || column.key === 'expand' || column.key === '' || column.sortable === false,
              'text-center':
                column.key === 'status' ||
                column.key === 'statusKey' ||
                column.key === 'result' ||
                column.key === 'addKey' ||
                column.key === 'loanStatus' ||
                column.key === 'lastAuditStatus' ||
                column.key === 'packet' ||
                column.key === 'queryStatus' ||
                column.key === 'currentStatus' ||
                column.key === 'picView' ||
                column.key === 'videoView' ||
                column.key === 'action' ||
                column.key === 'statusAction' ||
                column.key === 'actions' ||
                column.key === 'response' ||
                column.key === 'items' ||
                column.key === 'addKey' ||
                column.type === 'action',
              'text-left':
                column.key !== 'status' &&
                column.key !== 'statusKey' &&
                column.key !== 'result' &&
                column.key !== 'addKey' &&
                column.key !== 'loanStatus' &&
                column.key !== 'lastAuditStatus' &&
                column.key !== 'packet' &&
                column.key !== 'queryStatus' &&
                column.key !== 'currentStatus' &&
                column.key !== 'picView' &&
                column.key !== 'videoView' &&
                column.key !== 'action' &&
                column.key !== 'statusAction' &&
                column.key !== 'response' &&
                column.key !== 'items' &&
                column.key !== 'addKey' &&
                column.type !== 'action' &&
                column.key !== 'menu' &&
                column.key !== 'expand',
              'text-right': column.key === 'menu' || column.key === 'expand',
              'min-w-[5rem] w-24': column.key === 'addKey',
              'hidden md:table-cell': isSecurityStatusTable,
              'hidden': column.key === 'statusKey' && enableExpandableRows,
              'max-w-[360px]': column.wrapText || column.showTooltip,
              '!bg-[#FFFAD6] font-semibold text-[#25282D]':
                column.key === 'difference',
              '!bg-[#FBDEE0] font-semibold text-[#25282D]':
                column.key === 'mismatch'
            }"
          >
            <span
              class="flex items-center gap-1"
              [ngClass]="{
                'justify-center':
                  column.key === 'status' ||
                  column.key === 'statusKey' ||
                  column.key === 'result' ||
                  column.key === 'addKey' ||
                  column.key === 'loanStatus' ||
                  column.key === 'lastAuditStatus' ||
                  column.key === 'packet' ||
                  column.key === 'queryStatus' ||
                  column.key === 'picView' ||
                column.key === 'videoView' ||
                  column.key === 'action' ||
                  column.key === 'statusAction' ||
                  column.key === 'actions' ||
                  column.key === 'response' ||
                  column.key === 'items' ||
                  column.key === 'currentStatus' ||
                  column.type === 'action',
                'justify-start':
                  column.key !== 'status' &&
                  column.key !== 'statusKey' &&
                  column.key !== 'result' &&
                  column.key !== 'addKey' &&
                  column.key !== 'loanStatus' &&
                  column.key !== 'lastAuditStatus' &&
                  column.key !== 'packet' &&
                  column.key !== 'queryStatus' &&
                  column.key !== 'picView' &&
                column.key !== 'videoView' &&
                  column.key !== 'action' &&
                  column.key !== 'statusAction' &&
                  column.key !== 'response' &&
                  column.key !== 'items' &&
                  column.key !== 'currentStatus' &&
                  column.type !== 'action' &&
                  column.key !== 'menu',
                'justify-end': column.key === 'menu' || column.key === 'expand'
              }"
            >
              <span
                (click)="
                  column.key !== 'menu' && column.key !== 'expand' && column.key !== '' && (column.sortable !== false)
                    ? onSort(column.key)
                    : null
                "
              >
                {{ column.header }}
                @if (column.key !== 'menu' && column.key !== 'expand' && column.key !== '' && (column.sortable !== false)) {
                <span
                  class="ml-1 text-xs inline-block"
                  [ngClass]="{
                    'text-blue-600 font-semibold': isColumnSorted(column.key),
                    'text-gray-400': !isColumnSorted(column.key)
                  }"
                >
                  @if (isColumnSorted(column.key)) { @if (serverSideSorting) {
                  {{ currentSortDirection === "asc" ? "↑" : "↓" }}
                  } @else {
                  {{ sortDirection === "asc" ? "↑" : "↓" }}
                  } } @else { ⇅ }
                </span>
                }
              </span>
            </span>
          </th>
          }
          @if (enableExpandableRows || hasObservationImageColumns()) {
          <!-- Empty column for add/remove buttons -->
          <th
            class="px-4 py-2.5 font-normal text-sm bg-gray-100 sticky top-0 z-10 text-center"
          >
          </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of paginatedRows; track $index; let i = $index) {
        <!-- Nested child table: one row spanning full width with its own table (avoids column override with parent) -->
        @if (isChildRow(row) && isFirstChildRowInGroup(i) && childRowColumns && enableExpandableRows) {
        <tr class="border-b border-[#DBE0E6]">
          <td [attr.colspan]="visibleColumns.length + (enableExpandableRows || hasObservationImageColumns() ? 1 : 0)" class="align-top bg-[#F8F9FA] py-0">
            <table class="w-full border-collapse text-sm">
              <thead class="bg-[#EDE9FC]">
                <tr>
                  @for (col of getChildRowColumns(); track col.key) {
                  <th class="px-4 py-2 font-medium text-sm text-left text-[#25282D] whitespace-nowrap border-b border-[#DBE0E6]">
                    {{ col.header }}
                  </th>
                  }
                  <th class="px-4 py-2 font-medium text-sm text-center w-24 border-b border-[#DBE0E6]"></th>
                </tr>
              </thead>
              <tbody>
                @for (childRow of getChildRowsForParent(paginatedRows[getParentRowIndex(i)]); track $index; let childIdx = $index) {
                <tr class="bg-[#F8F9FA] hover:bg-[#F0F1F5] border-b border-[#DBE0E6] last:border-b-0">
                  @for (column of getChildRowColumns(); track column.key) {
                  <td class="py-[6px] px-4 font-normal text-sm align-middle max-w-[360px] min-w-0" [ngClass]="{ 'text-left text-[#717784]': column.key !== 'response' && column.key !== 'items' && column.key !== 'image', 'text-center': column.key === 'response' || column.key === 'items' || column.key === 'image' }">
                    <!-- Response (OK / Not OK) in nested child table; dropdown type uses parent-style dropdown if rendered -->
                    @if (column.key === 'response' && column.type !== 'dropdown') {
                    <ng-container>
                      @if (readonly && (childRow['response'] === '' || childRow['response'] == null || childRow['response'] === undefined)) {
                      <span class="text-sm text-[#717784]">-</span>
                      } @else {
                      <div class="flex items-center justify-center gap-3">
                        <app-action-button
                          [label]="'OK'"
                          [variant]="childRow['response'] === 'OK' ? 'filled' : 'outline'"
                          (clicked)="onResponseChange(childRow, 'OK', i + childIdx)"
                          [disabled]="readonly"
                          [buttonClass]="
                            childRow['response'] === 'OK'
                              ? '!bg-green-500 hover:!bg-green-600 !border-green-500 !text-white !w-12 !px-2 !h-8 !py-1 !rounded-md !text-[13px]'
                              : '!border-green-500 !text-green-500 !h-8 !rounded-md !text-[13px] hover:!bg-green-50 !w-12 !px-2 !h-7 !py-1 rounded-md text-xs'
                          "
                        ></app-action-button>
                        <app-action-button
                          [label]="'Not OK  '"
                          [variant]="childRow['response'] === 'Not OK' ? 'filled' : 'outline'"
                          (clicked)="onResponseChange(childRow, 'Not OK', i + childIdx)"
                          [disabled]="readonly"
                          [buttonClass]="
                            childRow['response'] === 'Not OK'
                              ? '!bg-red-500 hover:!bg-red-600 !border-red-500  !text-white !w-auto !h-8 !px-2 !py-1  !rounded-md !text-[13px] '
                              : '!border-red-500 !h-8  !rounded-md !text-[13px] !text-red-500 hover:!bg-red-50 !w-auto !px-2 !py-1 text-xs'
                          "
                        ></app-action-button>
                      </div>
                      }
                    </ng-container>
                    } @else if (column.key === 'items') {
                    <!-- Items image preview in nested child table -->
                    <div
                      class="sm:w-12 sm:h-12 w-10 h-10 border border-[#DBE0E6] rounded-md overflow-hidden cursor-pointer hover:border-[#6729FF] transition-colors mx-auto"
                      (click)="onItemsImageClick(childRow, i + childIdx)"
                    >
                      <img
                        [src]="childRow['itemsImage'] || '/assests/cctv-pic.jpg'"
                        alt="Item"
                        class="w-full h-full object-cover"
                      />
                    </div>
                    } @else if (column.key === 'image') {
                    <!-- Capture Image in nested child table -->
                    @if (readonly) {
                    @if (childRow['hasImage'] === true || childRow['hasImage'] === 'true' || childRow['imageFileName']) {
                    <button
                      type="button"
                      (click)="onViewImage(childRow, i + childIdx, $event)"
                      class="flex items-center justify-center gap-1 px-3 py-1.5 border border-dashed border-[#6729FF] rounded-md text-[#6729FF] text-xs font-medium hover:bg-purple-50 transition-colors mx-auto"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                      <span class="text-[11px]">View Image</span>
                    </button>
                    } @else {
                    <span class="text-gray-400 text-xs">No Image</span>
                    }
                    } @else {
                    <div class="max-w-[123px] mx-auto">
                      <div
                        class="w-full border-[#6729FF] border border-dashed rounded-md transition-all duration-200 relative"
                        [ngClass]="{
                          ' bg-[#F8F8FE] hover:border-[#6729FF] hover:bg-[#F0F0FF] cursor-pointer': !childRow['imageFileName'] && !childRow['hasImage'],
                          'border-green-500 bg-green-50 hover:bg-green-100 cursor-pointer': childRow['hasImage'] && !childRow['imageFileName'],
                          ' bg-white': childRow['imageFileName']
                        }"
                        (click)="!childRow['imageFileName'] && !childRow['hasImage'] && onImageCapture(childRow, i + childIdx)"
                      >
                        @if ((childRow['hasImage'] === true || childRow['hasImage'] === 'true') && !childRow['imageFileName']) {
                        <div class="py-1.5 px-2 flex items-center justify-center gap-2 min-h-[32px] cursor-pointer hover:bg-green-100 transition-colors" (click)="onViewImage(childRow, i + childIdx, $event)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="w-4 h-4 text-green-600"><path fill="currentColor" d="M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0 8a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5a5 5 0 0 1-5 5m0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5" /></svg>
                          <span class="text-xs text-green-600 whitespace-nowrap font-medium">View Image</span>
                        </div>
                        }
                        @if (!childRow['imageFileName'] && (childRow['hasImage'] !== true && childRow['hasImage'] !== 'true' && !childRow['hasImage'])) {
                        <div class="py-1.5 px-2 flex items-center justify-center gap-2 min-h-[32px]">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="w-4 h-4 text-[#6729FF]"><path fill="currentColor" d="M3 9a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1m5 11H5a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h3a1 1 0 0 0 0-2m4-12a4 4 0 1 0 4 4a4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2a2 2 0 0 1-2 2m7-12h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3m2 13a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 0 0 2h3a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1" stroke-width="1" stroke="currentColor" /></svg>
                          <span class="text-xs text-[#6729FF] whitespace-nowrap">Capture Image</span>
                        </div>
                        }
                        @if (childRow['imageFileName']) {
                        <div class="py-1.5 px-2 flex items-center justify-between gap-2 h-[32px] cursor-pointer hover:bg-gray-50 transition-colors" (click)="onViewImage(childRow, i + childIdx, $event)">
                          <div class="flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256" class="w-5 h-5 text-[#6729FF]"><path fill="currentColor" d="M216 44H40a12 12 0 0 0-12 12v144a12 12 0 0 0 12 12h176a12 12 0 0 0 12-12V56a12 12 0 0 0-12-12M40 52h176a4 4 0 0 1 4 4v112.4l-32.89-32.89a12 12 0 0 0-17 0l-22.83 22.83l-46.82-46.83a12 12 0 0 0-17 0L36 159V56a4 4 0 0 1 4-4m-4 148v-29.66l53.17-53.17a4 4 0 0 1 5.66 0L181.66 204H40a4 4 0 0 1-4-4m180 4h-23l-40-40l22.83-22.83a4 4 0 0 1 5.66 0L220 179.71V200a4 4 0 0 1-4 4m-68-104a8 8 0 1 1 8 8a8 8 0 0 1-8-8" /></svg>
                          </div>
                          <div class="flex-1 min-w-0"><span class="text-xs text-[#25282D] w-14 font-medium truncate block" [title]="childRow['imageFileName']">{{ childRow['imageFileName'] }}</span></div>
                          <button type="button" (click)="onDeleteImage(childRow, i + childIdx, $event)" class="flex-shrink-0 rounded transition-colors group" title="Delete image">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 text-[#96A0B5] group-hover:text-red-600 transition-colors"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                          </button>
                        </div>
                        }
                      </div>
                    </div>
                    }
                    } @else if (column.key === 'audit') {
                    <!-- Audit column (checkbox) in nested child table -->
                    <div class="flex items-center justify-center">
                      @if (readonly || readOnlyChildRows) {
                        <span class="text-sm text-[#25282D]">{{ childRow['audit'] === true ? 'Yes' : '-' }}</span>
                      } @else {
                        <input
                          type="checkbox"
                          [checked]="childRow['audit'] === true"
                          (change)="onAuditCheckboxChange(childRow, getParentRowIndex(i) + 1 + childIdx, $any($event.target).checked)"
                          class="w-4 h-4 text-[#6729FF] focus:ring-[#6729FF] border-[#DBE0E6] rounded cursor-pointer"
                        />
                      }
                    </div>
                    } @else if (column.key === 'auditRemark') {
                    <!-- Audit Remark column (input) in nested child table -->
                    @if (readOnlyChildRows) {
                      @if (column.showTooltip) {
                        <div
                          class="custom-tooltip-container truncate max-w-full cursor-help text-sm text-[#717784] min-w-0"
                          [attr.data-tooltip]="childRow['auditRemark'] || ''"
                          (mouseenter)="showTooltip($event, childRow['auditRemark'] || '')"
                          (mouseleave)="hideTooltip()"
                          (mousemove)="updateTooltipPosition($event)"
                        >
                          {{ getTruncatedDisplayText(childRow['auditRemark'], column) }}
                        </div>
                      } @else if (column.wrapText) {
                        <div class="max-w-[360px] break-words whitespace-normal text-sm text-[#717784]">{{ childRow['auditRemark'] || '-' }}</div>
                      } @else {
                        <span class="text-sm text-[#717784]">{{ childRow['auditRemark'] || '-' }}</span>
                      }
                    } @else {
                      <input
                        type="text"
                        [(ngModel)]="childRow['auditRemark']"
                        placeholder="Audit Remark"
                        class="w-full px-2 py-1.5 border border-[#DBE0E6] bg-[#F8F8FE] rounded-md focus:outline-none focus:ring-1 focus:ring-[#6729FF] focus:border-[#6729FF] text-sm text-[#25282D] placeholder:text-[#96A0B5]"
                      />
                    }
                    } @else if (childRow['isEditing'] && !column.readOnly && (!readOnlyChildRows || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], childRow)))) {
                    @if (column.key === 'particulars' || column.key === 'referenceNumber') {
                    <input
                      type="text"
                      [(ngModel)]="childRow[column.key]"
                      [placeholder]="column.header"
                      class="w-full px-2 py-1.5 border border-[#DBE0E6] bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-[#6729FF] focus:border-[#6729FF] text-[13px] text-[#25282D] placeholder:text-[#96A0B5]"
                    />
                    } @else if (column.key === 'quantity') {
                    <input
                      type="number"
                      [(ngModel)]="childRow[column.key]"
                      [placeholder]="column.header"
                      class="w-full px-2 py-1.5 border border-[#DBE0E6] bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-[#6729FF] focus:border-[#6729FF] text-[13px] text-[#25282D] placeholder:text-[#96A0B5] min-w-[60px]"
                    />
                    } @else if (column.key === 'statusKey') {
                    <div class="flex items-center gap-4">
                      <label class="flex items-center gap-2 cursor-pointer">
                        <input type="radio" [name]="'statusKey-nested-' + getParentRowIndex(i) + '-' + childIdx" value="Original" [(ngModel)]="childRow[column.key]" class="w-4 h-4 text-[#6729FF] focus:ring-[#6729FF] border-[#DBE0E6]" />
                        <span class="text-sm text-[#25282D]">Original</span>
                      </label>
                      <label class="flex items-center gap-2 cursor-pointer">
                        <input type="radio" [name]="'statusKey-nested-' + getParentRowIndex(i) + '-' + childIdx" value="Duplicate" [(ngModel)]="childRow[column.key]" class="w-4 h-4 text-[#6729FF] focus:ring-[#6729FF] border-[#DBE0E6]" />
                        <span class="text-sm text-[#25282D]">Duplicate</span>
                      </label>
                    </div>
                    } @else if (column.key === 'remarks') {
                    <input
                      type="text"
                      [(ngModel)]="childRow[column.key]"
                      (ngModelChange)="onRemarksChange(childRow, $event, i + childIdx)"
                      placeholder="Remarks"
                      [class]="hasFieldError(i + childIdx, 'remarks')
                        ? 'w-full min-w-[120px] px-2 py-1.5 border border-red-500 bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500 text-[13px] text-[#25282D] placeholder:text-[#96A0B5]'
                        : 'w-full min-w-[120px] px-2 py-1.5 border border-[#DBE0E6] bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-[#6729FF] text-[13px] text-[#25282D] placeholder:text-[#96A0B5]'"
                    />
                    } @else {
                    <span class="whitespace-nowrap">{{ getCellDisplayValue(childRow, column) }}</span>
                    }
                    } @else {
                    @if (column.key === 'remarks' && (column.wrapText || column.showTooltip)) {
                    <div class="break-words whitespace-normal text-sm">{{ getCellDisplayValue(childRow, column) }}</div>
                    } @else {
                    <span class="whitespace-nowrap">{{ getCellDisplayValue(childRow, column) }}</span>
                    }
                    }
                  </td>
                  }
                  <td class="py-1.5 px-4 font-normal text-sm text-center align-middle">
                    @if (enableExpandableRows && (!readOnlyChildRows || hasAuditColumns() || childRow['isEditing'] !== undefined || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], childRow)))) {
                    <div class="flex items-center justify-center gap-2">
                      @if (childRow['isEditing'] !== false && !hasAuditColumns() && !hideChildRowSaveIcon) {
                      <button
                        type="button"
                        (click)="saveChildRowClick.emit({ parentRow: paginatedRows[getParentRowIndex(i)], parentIndex: getParentRowIndex(i), childRow: childRow, childIndex: childIdx })"
                        class="inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-md bg-green-100 text-green-600 hover:bg-green-200 transition-colors touch-manipulation"
                        title="Save Key Entry"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>
                      </button>
                      }
                      @if (childRow['isEditing'] === false && (!readOnlyChildRows || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], childRow)))) {
                      <button
                        type="button"
                        (click)="editChildRowClick.emit({ parentRow: paginatedRows[getParentRowIndex(i)], parentIndex: getParentRowIndex(i), childRow: childRow, childIndex: childIdx })"
                        class="inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-md bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors touch-manipulation"
                        title="Edit Key Entry"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" /></svg>
                      </button>
                      }
                      @if ((!readOnlyChildRows || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], childRow))) && childRow['isEditing'] !== false && showDeleteButtonForChildRows) {
                      <button
                        type="button"
                        (click)="removeObservationImageRow(getParentRowIndex(i), childIdx)"
                        class="inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-md bg-red-100 text-red-600 hover:bg-red-200 transition-colors touch-manipulation"
                        title="Remove Key Entry"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                      </button>
                      }
                    </div>
                    } @else if (enableExpandableRows && readOnlyChildRows && !hasAuditColumns() && childRow['isEditing'] === undefined && !(showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], childRow))) {
                    <div></div>
                    }
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </td>
        </tr>
        } @else if (!(isChildRow(row) && childRowColumns && enableExpandableRows)) {
        <!-- Parent row or child row when not using nested table -->
        <!-- Key table header row (light purple) before first child - only when NOT using nested table -->
        @if (isChildRow(row) && isFirstChildRowInGroup(i) && childRowColumns && !enableExpandableRows) {
        <tr class="border-b border-[#DBE0E6] bg-[#EDE9FC]">
          @for (col of getChildRowColumns(); track col.key) {
          <th class="px-4 py-2 font-medium text-sm text-left text-[#25282D]">
            {{ col.header }}
          </th>
          }
          <th class="px-4 py-2 font-medium text-sm text-center"></th>
        </tr>
        }
        <tr
          class="group"
          [ngClass]="{
            'border-b border-[#DBE0E6]': !isNextRowSameParent(i),
            'bg-[#F8F9FA] hover:bg-[#F0F1F5]': isChildRow(row),
            'bg-white border-l-4 border-l-[#6729FF] hover:bg-[#f6f8fc]': !isChildRow(row) && enableExpandableRows,
            'hover:bg-[#f6f8fc]': !isChildRow(row) && !enableExpandableRows && !row['_isSkipped'],
            'bg-amber-100 text-amber-900 hover:bg-amber-100': row['_isSkipped'] === true
          }"
        >
          @for (column of (isChildRow(row) && childRowColumns ? getChildRowColumns() : visibleColumns); track column.key; let colIndex = $index) {
          <td
            class="relative py-[6px] px-4 font-normal text-sm align-middle"
            [ngClass]="{
              'whitespace-nowrap': !column.showTooltip && !column.wrapText,
              'overflow-visible': column.key === 'remarks',
              'text-center':
                column.key === 'status' ||
                column.key === 'result' ||
                column.key === 'addKey' ||
                column.key === 'audit' ||
                column.key === 'verified' ||
                column.key === 'loanStatus' ||
                column.key === 'auditStatus' ||
                column.key === 'lastAuditStatus' ||
                column.key === 'packet' ||
                column.key === 'auditQuery' ||
                column.key === 'queryStatus' ||
                column.key === 'currentStatus' ||
                column.key === 'picView' ||
                column.key === 'videoView' ||
                column.key === 'action' ||
                column.key === 'actions' ||
                column.key === 'response' ||
                column.key === 'items' ||
                column.key === 'addKey' ||
                column.type === 'action',
              'flex items-center justify-center': column.key === 'items',
              'text-left text-[#717784]':
                column.key !== 'status' &&
                column.key !== 'result' &&
                column.key !== 'addKey' &&
                column.key !== 'audit' &&
                column.key !== 'verified' &&
                column.key !== 'loanStatus' &&
                column.key !== 'auditStatus' &&
                column.key !== 'lastAuditStatus' &&
                column.key !== 'packet' &&
                column.key !== 'auditQuery' &&
                column.key !== 'queryStatus' &&
                column.key !== 'currentStatus' &&
                column.key !== 'picView' &&
                column.key !== 'videoView' &&
                column.key !== 'action' &&
                column.key !== 'response' &&
                column.key !== 'items' &&
                column.key !== 'addKey' &&
                column.type !== 'action' &&
                column.key !== 'menu',
              'text-right': column.key === 'menu' || column.key === 'expand',
              'bg-[#FFFEE9] text-yellow-500': column.key === 'difference',
              'bg-[#FFF0F1] text-red-500': column.key === 'mismatch',
              'hidden md:table-cell': isSecurityStatusTable,
              'max-w-[360px] align-top min-w-0': column.wrapText || column.showTooltip,
              'min-w-[5rem]': column.key === 'addKey',
              'min-w-[240px] align-top':
                isChildRow(row) && column.key === 'remarks',
              'font-semibold !text-[#000000]': !isChildRow(row) && column.key === 'vaultName',
            }"
          >
            <!-- Expand/Collapse Button Column -->
            @if (column.key === 'expand' && !isChildRow(row) && enableExpandableRows && !autoExpandAllRows) {
              @if (expandButtonStyle === 'icon' && (hasChildRows(row) || expandDetailTemplate)) {
              <div class="flex items-center justify-end">
                <button
                  class="p-1 rounded hover:bg-gray-200 transition-colors text-[#717784] hover:text-[#25282D]"
                  type="button"
                  (click)="toggleRowExpansion(row); $event.stopPropagation()"
                  [attr.title]="isRowExpanded(row) ? 'Collapse' : 'Expand'"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    class="w-4 h-4 transition-transform"
                    [class.rotate-90]="isRowExpanded(row)"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" d="m9 5 7 7-7 7" />
                  </svg>
                </button>
              </div>
              } @else if (expandButtonStyle === 'keys' && hasChildRows(row)) {
              <div class="flex items-center justify-end">
                <button
                  class="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full bg-[#6729FF] text-white hover:bg-[#5a1fe6] transition-colors"
                  type="button"
                  (click)="toggleRowExpansion(row); $event.stopPropagation()"
                  [attr.title]="isRowExpanded(row) ? 'Collapse' : 'Expand'"
                >
                  <span>Keys</span>
                  <span>{{ getChildRowCount(row) }}</span>
                  @if (isRowExpanded(row)) {
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-3.5 h-3.5"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" /></svg>
                  } @else {
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-3.5 h-3.5"><path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" /></svg>
                  }
                </button>
              </div>
              }
            }

            <!-- Menu Button -->
            @if (column.key === 'menu' && ((showMenu || showEdit) && shouldShowMenu() || (readonly && showMenuWhenReadonly?.(row)))) {
            <ng-container>
              @if (getRowMenuActions(row).showEdit || getRowMenuActions(row).showDelete) {
              <button
                class="lg:opacity-0 lg:group-hover:opacity-100 ml-auto"
                type="button"
                (click)="toggleMenu(i); $event.stopPropagation()"
              >
                <svg
                  class="relative top-[3px]"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 96 960 960"
                  width="24"
                  fill="currentColor"
                >
                  <circle cx="480" cy="336" r="48"></circle>
                  <circle cx="480" cy="560" r="48"></circle>
                  <circle cx="480" cy="780" r="48"></circle>
                </svg>
              </button>
              @if (openMenuIndex === i) {
              <div
                #dropdownMenu
                class="absolute text-left right-1 z-[20] bg-white shadow-lg border rounded-md w-24 transition-all duration-200"
                appClickOutside
                (clickOutside)="closeMenuOnOutsideClick(i)"
              >
                <ul class="py-1">
                  @if (getRowMenuActions(row).showEdit) {
                    @if (!editPermission || editPermission === '') {
                    <li
                      (click)="onEdit(row, i)"
                      class="px-2.5 py-1 text-[#000] cursor-pointer hover:bg-gray-200"
                    >
                      Edit
                    </li>
                    } @else {
                    <li
                      *appHasPermission="editPermission"
                      (click)="onEdit(row, i)"
                      class="px-2.5 py-1 text-[#000] cursor-pointer hover:bg-gray-200"
                    >
                      Edit
                    </li>
                    }
                  }
                  @if (getRowMenuActions(row).showDelete) {
                    @if (!deletePermission || deletePermission === '') {
                    <li
                      (click)="onDelete(row, i)"
                      class="px-2.5 py-1 text-[#000] cursor-pointer hover:bg-gray-200"
                    >
                      Delete
                    </li>
                    } @else {
                    <li
                      *appHasPermission="deletePermission"
                      (click)="onDelete(row, i)"
                      class="px-2.5 py-1 text-[#000] cursor-pointer hover:bg-gray-200"
                    >
                      Delete
                    </li>
                    }
                  }
                </ul>
              </div>
              }
              }
            </ng-container>
            }

            <!-- Dynamic Dropdown Column (type: 'dropdown') -->
            @if (column.type === 'dropdown') {
            <ng-container>
              @if (readonly) {
                <!-- Show plain text in readonly mode -->
                <span class="text-sm text-[#717784]">{{ getCellDisplayValue(row, column) }}</span>
              } @else {
                <div class="relative">
                  <app-dropdown
                    [options]="getDropdownOptions(column)"
                    [selectedOption]="row[column.key] || ''"
                    [placeholder]="column.placeholder || 'Select'"
                    [label]="''"
                    [disabled]="isColumnDisabled(row, column)"
                    [openUpward]="shouldOpenUpward(i)"
                    [buttonClass]="
                      isColumnDisabled(row, column)
                        ? '!bg-gray-100 !min-w-[160px] opacity-50 cursor-not-allowed !text-[13px] !h-[33px]'
                        : hasFieldError(i, column.key)
                          ? '!bg-white !min-w-[160px] !h-[33px] !text-[13px] !border-red-500 !ring-red-500'
                          : '!bg-white !min-w-[160px] !h-[33px] !text-[13px]'
                    "
                    (selectionChange)="onDropdownChange(row, column, $event, i)"
                    (dropdownOpen)="onDropdownOpen(i)"
                  ></app-dropdown>
                </div>
              }
            </ng-container>
            }

            <!-- Dynamic Input Column (type: 'input') - exclude 'remarks' which has its own block below -->
            @if (column.type === 'input' && column.key !== 'remarks') {
            <ng-container>
              @if (readonly) {
                @if (column.showTooltip) {
                  <div
                    class="custom-tooltip-container truncate max-w-full cursor-help text-sm text-[#717784] min-w-0"
                    [attr.data-tooltip]="row[column.key] || ''"
                    (mouseenter)="showTooltip($event, row[column.key] || '')"
                    (mouseleave)="hideTooltip()"
                    (mousemove)="updateTooltipPosition($event)"
                  >
                    {{ getTruncatedDisplayText(row[column.key], column) }}
                  </div>
                } @else {
                  <span class="text-sm text-[#717784]">{{ getCellDisplayValue(row, column) }}</span>
                }
              } @else {
                <div class="relative">
                  <input
                    type="text"
                    [(ngModel)]="row[column.key]"
                    (ngModelChange)="onInputChange(row, column, $event, i)"
                    [placeholder]="column.placeholder || column.header"
                    [disabled]="isColumnDisabled(row, column)"
                    [class]="isColumnDisabled(row, column)
                      ? 'w-full px-2 py-1.5 border border-[#DBE0E6] bg-gray-100 rounded-md text-sm text-[#25282D] placeholder:text-[#96A0B5] opacity-50 cursor-not-allowed'
                      : hasFieldError(i, column.key)
                        ? 'w-full px-2 py-1.5 border border-red-500 bg-[#F8F8FE] rounded-md focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500 text-sm text-[#25282D] placeholder:text-[#96A0B5]'
                        : 'w-full px-2 py-1.5 border border-[#DBE0E6] bg-[#F8F8FE] rounded-md focus:outline-none focus:ring-1 focus:ring-[#6729FF] focus:border-[#6729FF] text-sm text-[#25282D] placeholder:text-[#96A0B5]'"
                  />
                </div>
              }
            </ng-container>
            }

            <!-- Remarks Input -->
            @if (column.key === 'remarks') {
            <ng-container>
              @if (column.type === 'text' || readonly || (readOnlyRemarks && !(isChildRow(row) && row['isEditing'] === true && (!readOnlyChildRows || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], row))))) || (isChildRow(row) && (row['isEditing'] !== true || (readOnlyChildRows && !(showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], row)))))) {
                <!-- Plain text: type "text", readonly, readOnlyRemarks (except child row in edit mode), or child not editing. When showTooltip: 50 chars + full text in tooltip. -->
                @if (column.showTooltip) {
                  <div
                    class="custom-tooltip-container truncate max-w-full cursor-help text-sm text-[#717784] min-w-0"
                    [attr.data-tooltip]="row[column.key] || ''"
                    (mouseenter)="showTooltip($event, row[column.key] || '')"
                    (mouseleave)="hideTooltip()"
                    (mousemove)="updateTooltipPosition($event)"
                  >
                    {{ getTruncatedDisplayText(row[column.key], column) }}
                  </div>
                } @else if (isChildRow(row)) {
                  <div class="min-w-[240px] max-w-[420px] break-words whitespace-normal text-sm text-[#717784]">
                    {{ getCellDisplayValue(row, column) }}
                  </div>
                } @else {
                  <span class="text-sm text-[#717784]">{{ getCellDisplayValue(row, column) }}</span>
                }
              } @else {
                <div class="w-full relative">
                  <div class="relative h-[33px] flex items-center">
                    <input
                      type="text"
                      [(ngModel)]="row[column.key]"
                      (ngModelChange)="onRemarksChange(row, $event, i)"
                      placeholder="Remarks"
                      [disabled]="readonly"
                      [class]="hasFieldError(i, 'remarks')
                        ? (isChildRow(row)
                          ? 'w-full min-w-[240px] px-2 py-1.5 border border-red-500 bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500 text-[13px] text-[#25282D] placeholder:text-[#96A0B5]'
                          : 'w-full px-2 py-1.5 border border-red-500 bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-red-500 focus:border-red-500 text-[13px] text-[#25282D] placeholder:text-[#96A0B5]')
                        : (isChildRow(row)
                          ? 'w-full min-w-[240px] px-2 py-1.5 border border-[#DBE0E6] bg-white rounded-md focus:outline-none focus:!border-[#C7B1FF] focus:ring-[#C7B1FF] text-[13px] text-[#25282D] placeholder:text-[#96A0B5]'
                          : 'w-full px-2 py-1.5 border border-[#DBE0E6] bg-white rounded-md focus:outline-none focus:!border-[#C7B1FF] focus:ring-[#C7B1FF] text-[13px] text-[#25282D] placeholder:text-[#96A0B5]')"
                    />
                  </div>
                  <!-- @if (hasFieldError(i, 'remarks')) {
                  <div class="absolute top-[33px] left-0  px-1 text-xs text-red-500 italic whitespace-nowrap z-10 pointer-events-none">
                    {{ getFieldError(i, 'remarks') }}
                  </div>
                  } -->
                </div>
              }
            </ng-container>
            }

            <!-- Child row (key table) editable columns when edit icon is clicked; hidden when readOnlyChildRows (view-only) so only plain text shows, unless showChildRowActionsWhenReadonly allows -->
            @if (isChildRow(row) && row['isEditing'] && childRowColumns && !column.readOnly && (!readOnlyChildRows || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], row)))) {
            <ng-container>
              @if (column.key === 'particulars' || column.key === 'referenceNumber') {
              <input
                type="text"
                [(ngModel)]="row[column.key]"
                [placeholder]="column.header"
                class="w-full px-2 py-1.5 border border-[#DBE0E6] bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-[#6729FF] focus:border-[#6729FF] text-[13px] text-[#25282D] placeholder:text-[#96A0B5]"
              />
              }
              @else if (column.key === 'quantity') {
              <input
                type="number"
                [(ngModel)]="row[column.key]"
                [placeholder]="column.header"
                class="w-full px-2 py-1.5 border border-[#DBE0E6] bg-white rounded-md focus:outline-none focus:ring-1 focus:ring-[#6729FF] focus:border-[#6729FF] text-[13px] text-[#25282D] placeholder:text-[#96A0B5] min-w-[60px]"
              />
              }
              @else if (column.key === 'statusKey') {
              <div class="flex items-center gap-4">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="statusKey-{{ i }}"
                    value="Original"
                    [(ngModel)]="row[column.key]"
                    class="w-4 h-4 text-[#6729FF] focus:ring-[#6729FF] border-[#DBE0E6]"
                  />
                  <span class="text-sm text-[#25282D]">Original</span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="statusKey-{{ i }}"
                    value="Duplicate"
                    [(ngModel)]="row[column.key]"
                    class="w-4 h-4 text-[#6729FF] focus:ring-[#6729FF] border-[#DBE0E6]"
                  />
                  <span class="text-sm text-[#25282D]">Duplicate</span>
                </label>
              </div>
              }
            </ng-container>
            }

            <!-- Child row: Audit column (checkbox; disabled when readonly or readOnlyChildRows) -->
            @if (isChildRow(row) && column.key === 'audit') {
            <ng-container>
              <div class="flex items-center justify-center">
                @if (readonly || readOnlyChildRows) {
                  <span class="text-sm text-[#25282D]">{{ row['audit'] === true ? 'Yes' : '-' }}</span>
                } @else {
                  <input
                    type="checkbox"
                    [checked]="row['audit'] === true"
                    (change)="onAuditCheckboxChange(row, i, $any($event.target).checked)"
                    class="w-4 h-4 text-[#6729FF] focus:ring-[#6729FF] border-[#DBE0E6] rounded cursor-pointer"
                  />
                }
              </div>
            </ng-container>
            }

            <!-- Child row: Audit Remark column (text when readOnlyChildRows, else editable input). When showTooltip: 50 chars + full text in tooltip. -->
            @if (isChildRow(row) && column.key === 'auditRemark') {
            <ng-container>
              @if (readOnlyChildRows) {
                @if (column.showTooltip) {
                  <div
                    class="custom-tooltip-container truncate max-w-full cursor-help text-sm text-[#717784] min-w-0"
                    [attr.data-tooltip]="row['auditRemark'] || ''"
                    (mouseenter)="showTooltip($event, row['auditRemark'] || '')"
                    (mouseleave)="hideTooltip()"
                    (mousemove)="updateTooltipPosition($event)"
                  >
                    {{ getTruncatedDisplayText(row['auditRemark'], column) }}
                  </div>
                } @else if (column.wrapText) {
                  <div class="max-w-[360px] break-words whitespace-normal text-sm text-[#717784]">{{ row['auditRemark'] || '-' }}</div>
                } @else {
                  <span class="text-sm text-[#717784]">{{ row['auditRemark'] || '-' }}</span>
                }
              } @else {
                <input
                  type="text"
                  [(ngModel)]="row['auditRemark']"
                  placeholder="Audit Remark"
                  class="w-full px-2 py-1.5 border border-[#DBE0E6] bg-[#F8F8FE] rounded-md focus:outline-none focus:ring-1 focus:ring-[#6729FF] focus:border-[#6729FF] text-sm text-[#25282D] placeholder:text-[#96A0B5]"
                />
              }
            </ng-container>
            }

            <!-- Response Buttons (or dash in readonly when no response from backend).
                 Skipped when type is 'dropdown' — response uses the generic dropdown block above. -->
            @if (column.key === 'response' && column.type !== 'dropdown') {
            <ng-container>
              @if (readonly && (row['response'] === '' || row['response'] == null || row['response'] === undefined)) {
                <span class="text-sm text-[#717784]">-</span>
              } @else {
              <div class="flex items-center justify-center gap-3">
                <app-action-button
                  [label]="'OK'"
                  [variant]="row['response'] === 'OK' ? 'filled' : 'outline'"
                  (clicked)="onResponseChange(row, 'OK', i)"
                  [disabled]="readonly"
                  [buttonClass]="
                    row['response'] === 'OK'
                      ? '!bg-green-500 hover:!bg-green-600 !border-green-500 !text-white !w-12 !px-2 !h-8 !py-1 !rounded-md !text-[13px]'
                      : '!border-green-500 !text-green-500 !h-8 !rounded-md !text-[13px] hover:!bg-green-50 !w-12 !px-2 !h-7 !py-1 rounded-md text-xs'
                  "
                ></app-action-button>
                <app-action-button
                  [label]="'Not OK  '"
                  [variant]="row['response'] === 'Not OK' ? 'filled' : 'outline'"
                  (clicked)="onResponseChange(row, 'Not OK', i)"
                  [disabled]="readonly"
                  [buttonClass]="
                    row['response'] === 'Not OK'
                      ? '!bg-red-500 hover:!bg-red-600 !border-red-500  !text-white !w-auto !h-8 !px-2 !py-1  !rounded-md !text-[13px] '
                      : '!border-red-500 !h-8  !rounded-md !text-[13px] !text-red-500 hover:!bg-red-50 !w-auto !px-2 !py-1 text-xs'
                  "
                ></app-action-button>
              </div>
              }
            </ng-container>
            }

            <!-- Key Remarks (plain text when readonly; otherwise editable input) -->
            @if (column.key === 'keyRemarks') {
            <ng-container>
              @if (readonly) {
              <span class="text-sm text-[#717784]">{{ getCellDisplayValue(row, column) }}</span>
              } @else {
              <input
                type="text"
                [(ngModel)]="row[column.key]"
                [placeholder]="column.placeholder || column.header"
                class="w-full px-2 py-1.5 border border-[#DBE0E6] bg-[#F8F8FE] rounded-md focus:outline-none focus:ring-1 focus:ring-[#6729FF] focus:border-[#6729FF] text-sm text-[#25282D] placeholder:text-[#96A0B5]"
              />
              }
            </ng-container>
            }

            <!-- Items Image Preview -->
            @if (column.key === 'items') {
            <ng-container>
              <div
                class="sm:w-12 sm:h-12 w-10 h-10 border border-[#DBE0E6] rounded-md overflow-hidden cursor-pointer hover:border-[#6729FF] transition-colors"
                (click)="onItemsImageClick(row, i)"
              >
                <img
                  [src]="row['itemsImage'] || '/assests/cctv-pic.jpg'"
                  alt="Item"
                  class="w-full h-full object-cover"
                />
              </div>
            </ng-container>
            }

            <!-- Image Capture -->
            @if (column.key === 'image') {
            @if (readonly) {
            <!-- Readonly mode - show image if exists, otherwise show dash -->
            <ng-container>
              @if (row['hasImage'] === true || row['hasImage'] === 'true' || row['imageFileName']) {
              <button
                type="button"
                (click)="onViewImage(row, i, $event)"
                class="flex items-center justify-center gap-1 px-3 py-1.5 border border-dashed border-[#6729FF] rounded-md text-[#6729FF] text-xs font-medium hover:bg-purple-50 transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <span class="text-[11px]">View Image</span>
              </button>
              } @else {
              <span class="text-gray-400 text-xs">No Image</span>
              }
            </ng-container>
            } @else {
            <ng-container>
              <div class="max-w-[123px]">
                <!-- Rectangle Box Container -->
                <div
                  class="w-full border-[#6729FF] border border-dashed rounded-md transition-all duration-200 relative"
                  [ngClass]="{
                    ' bg-[#F8F8FE] hover:border-[#6729FF] hover:bg-[#F0F0FF] cursor-pointer':
                      !row['imageFileName'] && !row['hasImage'],
                    'border-green-500 bg-green-50 hover:bg-green-100 cursor-pointer':
                      row['hasImage'] && !row['imageFileName'],
                    ' bg-white': row['imageFileName']
                  }"
                  (click)="
                    !row['imageFileName'] &&
                      !row['hasImage'] &&
                      onImageCapture(row, i)
                  "
                >
                  <!-- Has Image (from backend) - Show View Image Button -->
                  @if ((row['hasImage'] === true || row['hasImage'] === 'true')
                  && !row['imageFileName']) {
                  <div
                    class="py-1.5 px-2 flex items-center justify-center gap-2 min-h-[32px] cursor-pointer hover:bg-green-100 transition-colors"
                    (click)="onViewImage(row, i, $event)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      class="w-4 h-4 text-green-600"
                    >
                      <path
                        fill="currentColor"
                        d="M12 9a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3m0 8a5 5 0 0 1-5-5a5 5 0 0 1 5-5a5 5 0 0 1 5 5a5 5 0 0 1-5 5m0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5"
                      />
                    </svg>
                    <span
                      class="text-xs text-green-600 whitespace-nowrap font-medium"
                      >View Image</span
                    >
                  </div>
                  }

                  <!-- No Image State - Show Camera Icon -->
                  @if (!row['imageFileName'] && (row['hasImage'] !== true &&
                  row['hasImage'] !== 'true' && !row['hasImage'])) {
                  <div
                    class="py-1.5 px-2 flex items-center justify-center gap-2 min-h-[32px]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      class="w-4 h-4 text-[#6729FF]"
                    >
                      <path
                        fill="currentColor"
                        d="M3 9a1 1 0 0 0 1-1V5a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1m5 11H5a1 1 0 0 1-1-1v-3a1 1 0 0 0-2 0v3a3 3 0 0 0 3 3h3a1 1 0 0 0 0-2m4-12a4 4 0 1 0 4 4a4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2a2 2 0 0 1-2 2m7-12h-3a1 1 0 0 0 0 2h3a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5a3 3 0 0 0-3-3m2 13a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 0 0 2h3a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1"
                        stroke-width="1"
                        stroke="currentColor"
                      />
                    </svg>
                    <span class="text-xs text-[#6729FF] whitespace-nowrap"
                      >Capture Image</span
                    >
                  </div>
                  }

                  <!-- Image Captured State - Show Image Icon, Name, and Delete -->
                  @if (row['imageFileName']) {
                  <div
                    class="py-1.5 px-2 flex items-center justify-between gap-2 h-[32px] cursor-pointer hover:bg-gray-50 transition-colors"
                    (click)="onViewImage(row, i, $event)"
                  >
                    <!-- Image Icon -->
                    <div class="flex-shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 256 256"
                        class="w-5 h-5 text-[#6729FF]"
                      >
                        <path
                          fill="currentColor"
                          d="M216 44H40a12 12 0 0 0-12 12v144a12 12 0 0 0 12 12h176a12 12 0 0 0 12-12V56a12 12 0 0 0-12-12M40 52h176a4 4 0 0 1 4 4v112.4l-32.89-32.89a12 12 0 0 0-17 0l-22.83 22.83l-46.82-46.83a12 12 0 0 0-17 0L36 159V56a4 4 0 0 1 4-4m-4 148v-29.66l53.17-53.17a4 4 0 0 1 5.66 0L181.66 204H40a4 4 0 0 1-4-4m180 4h-23l-40-40l22.83-22.83a4 4 0 0 1 5.66 0L220 179.71V200a4 4 0 0 1-4 4m-68-104a8 8 0 1 1 8 8a8 8 0 0 1-8-8"
                        />
                      </svg>
                    </div>

                    <!-- Image Name -->
                    <div class="flex-1 min-w-0">
                      <span
                        class="text-xs text-[#25282D] w-14 font-medium truncate block"
                        [title]="row['imageFileName']"
                      >
                        {{ row["imageFileName"] }}
                      </span>
                    </div>

                    <!-- Delete Icon -->
                    <button
                      type="button"
                      (click)="onDeleteImage(row, i, $event)"
                      class="flex-shrink-0 rounded transition-colors group"
                      title="Delete image"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        class="w-4 h-4 text-[#96A0B5] group-hover:text-red-600 transition-colors"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                  }
                </div>
              </div>
            </ng-container>
            }
            }

            <!-- Verified (green checkmark) column -->
            @if (column.key === 'verified') {
            <ng-container>
              <div class="flex items-center justify-center">
                @if (row['response'] === 'OK' || row['response'] === 'Not OK') {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-green-600">
                  <path d="M20 6L9 17l-5-5"/>
                </svg>
                } @else {
                <span class="text-[#96A0B5]">-</span>
                }
              </div>
            </ng-container>
            }

            <!-- Result Badge -->
            @if (column.key === 'result') {
            <ng-container>
              @if (shouldShowBadge(column, row[column.key])) {
              <span
                class="inline-flex items-center justify-center px-2.5 py-1 rounded-md text-xs font-medium mx-auto"
                [ngClass]="getBadgeColor(row[column.key], column.key)"
              >
                {{ row[column.key] }}
              </span>
              }
            </ng-container>
            }

            <!-- Status Badge -->
            @if ( column.type !== 'text' && (column.key === 'status' || column.key === 'loanStatus' ||
            column.key === 'auditStatus' || column.key === 'lastAuditStatus' ||
            column.key === 'packet' || column.key === 'auditQuery' || column.key
            === 'queryStatus' || column.key === 'currentStatus' || column.key
            === 'source' || column.key === 'typeStatus' || column.key ===
            'action') && shouldShowBadge(column, row[column.key]) &&
            !(column.key === 'action' && (row['action'] === 'Start' || row['action'] === 'Start Audit' ||
            row['action'] === 'Resume' || row['action'] === 'Resume Audit' || isViewAction(row['action']))) )
            {
            <ng-container>
              <span
                class="inline-flex items-center justify-center px-2.5 py-1 rounded-md text-xs font-medium mx-auto whitespace-nowrap min-w-0 max-w-full"
                [ngClass]="getBadgeColor(row[column.key], column.key)"
              >
                {{ row[column.key] }}
              </span>
            </ng-container>
            } @else if (column.key === 'auditQuery' && !shouldShowBadge(column,
            row[column.key])) {
            <ng-container>
              <span class="pl-8">-</span>
            </ng-container>
            } @else if (column.key === 'queryStatus' && !shouldShowBadge(column,
            row[column.key])) {
            <ng-container>
              <span class="flex items-center justify-center">-</span>
            </ng-container>
            }

            <!-- ID with click -->
            @if (column.key === 'id') {
            <ng-container>
              <span
                (click)="onIdClicked?.(row[column.key])"
                class="text-sm inline-block"
                [ngClass]="{
                  'text-[#0052FF] no-underline cursor-pointer':
                    useRouterNavigate
                }"
              >
                {{ row[column.key] }}
              </span>
            </ng-container>
            }

            <!-- User ID with click -->
            @if (column.key === 'userId' && onIdClicked) {
            <ng-container>
              <span
                (click)="
                  onIdClicked(row['userIdForNavigation'] || row[column.key])
                "
                class="text-sm inline-block text-[#0052FF] cursor-pointer hover:underline"
              >
                {{ row[column.key] }}
              </span>
            </ng-container>
            }

            <!-- Column with custom click handler as button (type action) -->
            @if (columnClickHandlers && columnClickHandlers[column.key] && column.type === 'action') {
            <ng-container>
              <div class="flex items-center justify-center">
                <app-action-button
                  [label]="row[column.key] || ''"
                  variant="outline"
                  [loading]="row[column.key + 'Loading'] === true"
                  [disabled]="row[column.key + 'Disabled'] === true"
                  [buttonClass]="'!px-3 !py-1.5 !text-xs !font-semibold !rounded-lg'"
                  (clicked)="columnClickHandlers[column.key](row)"
                ></app-action-button>
              </div>
            </ng-container>
            }

            <!-- Column with custom click handler (link style) -->
            @if (columnClickHandlers && columnClickHandlers[column.key] && column.type !== 'action') {
            <ng-container>
              <span
                (click)="columnClickHandlers[column.key](row)"
                class="text-sm inline-block text-[#0052FF] cursor-pointer hover:underline"
              >
                {{ row[column.key] }}
              </span>
            </ng-container>
            }

            <!-- Pic View Button -->
            @if (column.key === 'picView') {
            <ng-container>
              <div class="flex items-center justify-center">
                @if (row[column.key]) {
                <app-action-button
                  [label]="'View'"
                  [variant]="'outline'"
                  [iconLeft]="getEyeIcon()"
                  [loading]="picViewLoadingRowIndex === i"
                  (clicked)="onPicViewClick(row, i)"
                  buttonClass="!w-20 gap-1.5 !px-3 !text-[11px] h-7"
                ></app-action-button>
                }
              </div>
            </ng-container>
            }

            @if (column.key === 'videoView') {
            <ng-container>
              <div class="flex items-center justify-center">
                @if (row[column.key]) {
                <app-action-button
                  [label]="'View'"
                  [variant]="'outline'"
                  [iconLeft]="getVideoIcon()"
                  [loading]="videoViewLoadingRowIndex === i"
                  (clicked)="onVideoViewClick(row, i)"
                  buttonClass="!w-20 gap-1.5 !px-3 !text-[11px] h-7"
                ></app-action-button>
                }
              </div>
            </ng-container>
            }

            <!-- Actions Column (Edit and Delete Icons); column is omitted when readonly via visibleColumns -->
            @if (column.key === 'actions') {
            <ng-container>
              <div class="flex items-center justify-center gap-3.5">
                <!-- Edit Icon (only when showEdit is true) -->
                @if (showEdit) {
                @if (!editPermission || editPermission === '') {
                <button
                  (click)="onEdit(row, i)"
                  class="hover:bg-blue-50 rounded transition-colors"
                  title="Edit"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-[18px] h-[18px] text-[#96A0B5] hover:text-blue-600 transition-colors"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                    />
                  </svg>
                </button>
                } @else {
                <button
                  *appHasPermission="editPermission"
                  (click)="onEdit(row, i)"
                  class="hover:bg-blue-50 rounded transition-colors"
                  title="Edit"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-[18px] h-[18px] text-[#96A0B5] hover:text-blue-600 transition-colors"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                    />
                  </svg>
                </button>
                }
                }
                <!-- Delete Icon (only when showDelete is true) -->
                @if (showDelete) {
                @if (!deletePermission || deletePermission === '') {
                <button
                  (click)="onDelete(row, i)"
                  class="hover:bg-red-50 rounded transition-colors"
                  title="Delete"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-[18px] h-[18px] text-[#96A0B5] hover:text-red-600 transition-colors"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                    />
                  </svg>
                </button>
                } @else {
                <button
                  *appHasPermission="deletePermission"
                  (click)="onDelete(row, i)"
                  class="hover:bg-red-50 rounded transition-colors"
                  title="Delete"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-[18px] h-[18px] text-[#96A0B5] hover:text-red-600 transition-colors"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                    />
                  </svg>
                </button>
                }
                }
              </div>
            </ng-container>
            }

            <!-- Action Button (Start, Start Audit, Resume Audit, or View) - uniform size/alignment -->
            @if (column.key === 'action') {
            <ng-container>
              <div class="flex items-center justify-center">
                <!-- Start Button (e.g. Key Movement Receiver IN_TRANSIT) -->
                @if (row['action'] === 'Start') {
                <app-action-button
                  [label]="'Start'"
                  [variant]="'outline'"
                  [iconLeft]="getStartAuditIcon()"
                  [disabled]="row['actionDisabled'] === true"
                  [loading]="loadingActionRowId === row['id']"
                  (clicked)="onStartAuditClick(row)"
                  buttonClass="gap-1 !rounded-md md:w-[130px] !px-2 sm:!px-3 !text-[11px] sm:!text-[12px] !h-6 sm:!h-7 !justify-center"
                ></app-action-button>
                } @else if (row['action'] === 'Start Audit') {
                <!-- Start Audit Button -->
                <app-action-button
                  [label]="'Start Audit'"
                  [variant]="'outline'"
                  [iconLeft]="getStartAuditIcon()"
                  [disabled]="row['actionDisabled'] === true"
                  [loading]="loadingActionRowId === row['id']"
                  (clicked)="onStartAuditClick(row)"
                  buttonClass="gap-1 !rounded-md md:w-[130px] !px-2 sm:!px-3 !text-[11px] sm:!text-[12px] !h-6 sm:!h-7 !justify-center"
                ></app-action-button>
                } @else if (row['action'] === 'Resume' || row['action'] === 'Resume Audit') {
                <!-- Resume Button (label from adapter: Resume or Resume Audit) -->
                <app-action-button
                  [label]="getResumeActionLabel(row['action'])"
                  [variant]="'outline'"
                  [iconLeft]="getResumeIcon()"
                  [loading]="loadingActionRowId === row['id']"
                  (clicked)="onStartAuditClick(row)"
                  buttonClass="gap-1 !rounded-md md:w-[130px] !px-2 sm:!px-3 !text-[11px] sm:!text-[12px] !h-6 sm:!h-7 !justify-center"
                ></app-action-button>
                } @else if (isViewAction(row['action'])) {
                <!-- View Button -->
                <app-action-button
                  [label]="getActionLabel(row['action'])"
                  [variant]="'outline'"
                  [iconLeft]="getEyeIcon()"
                  [disabled]="row['actionDisabled'] === true"
                  [loading]="loadingActionRowId === row['id']"
                  (clicked)="onViewClick(row)"
                  buttonClass="gap-1 !rounded-md md:w-[130px] !px-2 sm:!px-3 !text-[11px] sm:!text-[12px] !h-6 sm:!h-7 !justify-center"
                ></app-action-button>
                }
              </div>
            </ng-container>
            }

            <!-- Status Action Column (buttons based on status) - uniform size/alignment -->
            @if (column.key === 'statusAction') {
            <ng-container>
              <div class="flex items-center justify-center">
                <!-- Completed → View Audit Button -->
                @if (row['status'] && row['status'].toLowerCase().trim() ===
                'completed') {
                <app-action-button
                  [label]="'View Audit'"
                  [variant]="'outline'"
                  [iconLeft]="getEyeIcon()"
                  [loading]="loadingActionRowId === row['id']"
                  (clicked)="onViewClick(row)"
                  buttonClass="gap-1 !rounded-md md:w-[130px] !px-2 sm:!px-3 !text-[11px] sm:!text-[12px] !h-6 sm:!h-7 !justify-center"
                ></app-action-button>
                }
                <!-- In Progress → Resume Audit Button -->
                @if (row['status'] && (row['status'].toLowerCase().trim() ===
                'in progress' || row['status'].toLowerCase().trim() ===
                'inprogress')) {
                <app-action-button
                  [label]="'Resume Audit'"
                  [variant]="'outline'"
                  [iconLeft]="getResumeIcon()"
                  [loading]="loadingActionRowId === row['id']"
                  (clicked)="onInProgressAuditClick(row)"
                  buttonClass="gap-1 !rounded-md md:w-[130px] !px-2 sm:!px-3 !text-[11px] sm:!text-[12px] !h-6 sm:!h-7 !justify-center"
                ></app-action-button>
                }
                <!-- Pending → Start Audit Button -->
                @if (row['status'] && row['status'].toLowerCase().trim() ===
                'pending') {
                <app-action-button
                  [label]="'Start Audit'"
                  [variant]="'outline'"
                  [iconLeft]="getStartAuditIcon()"
                  [disabled]="row['actionDisabled'] === true"
                  [loading]="loadingActionRowId === row['id']"
                  (clicked)="onStartAuditClick(row)"
                  buttonClass="gap-1 !rounded-md md:w-[130px] !px-2 sm:!px-3 !text-[11px] sm:!text-[12px] !h-6 sm:!h-7 !justify-center"
                ></app-action-button>
                }
              </div>
            </ng-container>
            }

            <!-- Add Key Column (circular purple button with white plus - opens modal in parent; hidden when readonly) -->
            @if (column.key === 'addKey') {
            <ng-container>
              @if (!isChildRow(row) && (!readonly || (readonly && showAddKeyWhenReadonly?.(row)))) {
              <div class="flex items-center justify-center">
                <button
                  type="button"
                  (click)="onAddKeyColumnClick(row, i)"
                  class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#6729FF] text-white hover:bg-[#5a1fe6] transition-colors touch-manipulation"
                  title="Add Key Entry"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                    <path d="M5 13v-1h6V6h1v6h6v1h-6v6h-1v-6z"/>
                  </svg>
                </button>
              </div>
              }
            </ng-container>
            }

            <!-- Column with Link Route -->
            @if (hasLinkRoute(column)) {
            <ng-container>
              <a
                [routerLink]="getColumnRoute(column, row)"
                class="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer transition-colors"
              >
                {{ row[column.key] }}
              </a>
            </ng-container>
            }

            <!-- Default Content (plain text; for child rows, particulars/quantity/referenceNumber/statusKey show here when column.readOnly). Exclude remarks – it has its own block above. -->
            @if ( ((column.type === 'text' && column.key !== 'remarks') || (!hasLinkRoute(column) && column.type !== 'dropdown' &&
            column.type !== 'input' && column.type !== 'badge' && column.type !== 'action' &&
            column.key !== 'menu' && column.key !== 'expand' && column.key !== 'addKey' && column.key
            !== 'status' && column.key !== 'result' && column.key !== 'id' &&
            !(column.key === 'userId' && onIdClicked) && column.key !== 'registerStatus' && column.key !==
            'observation' && column.key !== 'remarks' && column.key !==
            'response' && column.key !== 'items' && column.key !== 'image' &&
            column.key !== 'keyRemarks' && column.key !== 'verified' &&
            column.key !== 'picView' && column.key !== 'videoView' && column.key !== 'action' && column.key
            !== 'statusAction' && column.key !== 'actions' && column.key !==
            'loanStatus' && column.key !== 'auditStatus' && column.key !==
            'lastAuditStatus' && column.key !== 'packet' && column.key !==
            'auditQuery' && column.key !== 'queryStatus' && column.key !==
            'currentStatus' && column.key !== 'source' && column.key !==
            'typeStatus' && !(columnClickHandlers &&
            columnClickHandlers[column.key]))) && !(isChildRow(row) && row['isEditing'] && (!readOnlyChildRows || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], row))) && !column.readOnly && (column.key === 'particulars' || column.key === 'quantity' || column.key === 'referenceNumber' || column.key === 'statusKey')) && !(isChildRow(row) && (column.key === 'audit' || column.key === 'auditRemark')) ) {
            <ng-container>
              @if (column.key === expandInColumnKey && expandInColumnKey && !isChildRow(row) && enableExpandableRows && !autoExpandAllRows && expandButtonStyle === 'icon' && (hasChildRows(row) || expandDetailTemplate)) {
              <div class="flex items-center gap-2">
                <button
                  class="p-1 rounded hover:bg-gray-200 transition-colors text-[#717784] hover:text-[#25282D] shrink-0"
                  type="button"
                  (click)="toggleRowExpansion(row); $event.stopPropagation()"
                  [attr.title]="isRowExpanded(row) ? 'Collapse' : 'Expand'"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    class="w-4 h-4 transition-transform"
                    [class.rotate-90]="isRowExpanded(row)"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" d="m9 5 7 7-7 7" />
                  </svg>
                </button>
                @if (column.showTooltip) {
                  <div
                    class="custom-tooltip-container truncate max-w-full cursor-help"
                    [attr.data-tooltip]="row[column.key] || ''"
                    (mouseenter)="showTooltip($event, row[column.key] || '')"
                    (mouseleave)="hideTooltip()"
                    (mousemove)="updateTooltipPosition($event)"
                  >
                    {{ getTruncatedDisplayText(row[column.key], column) }}
                  </div>
                } @else if (column.wrapText) {
                  <div class="max-w-[360px] break-words whitespace-normal text-sm text-[#717784]">
                    {{ getCellDisplayValue(row, column) }}
                  </div>
                } @else {
                  <div [innerHTML]="row[column.key]"></div>
                }
              </div>
              } @else {
              @if (column.showTooltip) {
                <div
                  class="custom-tooltip-container truncate max-w-full cursor-help"
                  [attr.data-tooltip]="row[column.key] || ''"
                  (mouseenter)="showTooltip($event, row[column.key] || '')"
                  (mouseleave)="hideTooltip()"
                  (mousemove)="updateTooltipPosition($event)"
                >
                  {{ getTruncatedDisplayText(row[column.key], column) }}
                </div>
              } @else if (column.wrapText) {
                <div class="max-w-[360px] break-words whitespace-normal text-sm text-[#717784]">
                  {{ getCellDisplayValue(row, column) }}
                </div>
              } @else {
                <div [innerHTML]="row[column.key]"></div>
              }
              }
            </ng-container>
            }
          </td>
          }
          <!-- Add/Remove Button Column -->
          @if (enableExpandableRows || hasObservationImageColumns()) {
          <td
            class="relative py-1.5 sm:py-[6px] px-2 sm:px-3 md:px-4 font-normal text-xs sm:text-sm text-center"
          >
            @if (isChildRow(row)) {
              @if (enableExpandableRows && (!readOnlyChildRows || hasAuditColumns() || row['isEditing'] !== undefined || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], row)))) {
              <div class="flex items-center justify-center gap-2">
                @if (row['isEditing'] !== false && !hasAuditColumns()) {
                <button
                  type="button"
                  (click)="saveChildRowClick.emit({ parentRow: paginatedRows[getParentRowIndex(i)], parentIndex: getParentRowIndex(i), childRow: row, childIndex: getChildRowIndex(i) })"
                  class="inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-md bg-green-100 text-green-600 hover:bg-green-200 transition-colors touch-manipulation"
                  title="Save Key Entry"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>
                </button>
                }
                @if (row['isEditing'] === false && (!readOnlyChildRows || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], row)))) {
                <button
                  type="button"
                  (click)="editChildRowClick.emit({ parentRow: paginatedRows[getParentRowIndex(i)], parentIndex: getParentRowIndex(i), childRow: row, childIndex: getChildRowIndex(i) })"
                  class="inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-md bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors touch-manipulation"
                  title="Edit Key Entry"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" /></svg>
                </button>
                }
                @if ((!readOnlyChildRows || (showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], row))) && row['isEditing'] !== false && showDeleteButtonForChildRows) {
                <button
                  type="button"
                  (click)="removeObservationImageRow(getParentRowIndex(i), getChildRowIndex(i))"
                  class="inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-md bg-red-100 text-red-600 hover:bg-red-200 transition-colors touch-manipulation"
                  title="Remove Key Entry"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
                }
              </div>
              } @else if (enableExpandableRows && readOnlyChildRows && !hasAuditColumns() && row['isEditing'] === undefined && !(showChildRowActionsWhenReadonly && showChildRowActionsWhenReadonly(paginatedRows[getParentRowIndex(i)], row))) {
              <div></div>
              } @else if (!readonly) {
              <button
                type="button"
                (click)="removeObservationImageRow(getParentRowIndex(i), getChildRowIndex(i))"
                class="inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-red-100 text-red-600 hover:bg-red-200 transition-colors touch-manipulation"
                title="Remove observation/image row"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
              }
            } @else if (hasObservationImageColumns() && !readonly) {
            <button
              type="button"
              (click)="addObservationImageRow(i)"
              class="inline-flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-[#6729FF] text-white hover:bg-[#5a1fe6] transition-colors touch-manipulation"
              title="Add observation/image row"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" /></svg>
            </button>
            }
          </td>
          }
        </tr>
        @if (expandDetailTemplate && !isChildRow(row) && isRowExpanded(row)) {
        <tr class="border-b border-[#DBE0E6] bg-[#F8F9FA]">
          <td [attr.colspan]="(enableExpandableRows || hasObservationImageColumns() ? columns.length + 1 : columns.length)" class="py-2 px-4 align-top">
            <ng-container *ngTemplateOutlet="expandDetailTemplate; context: { $implicit: row }"></ng-container>
          </td>
        </tr>
        }
        }
        } @if (rows.length === 0) {
        <tr>
          <td
            [attr.colspan]="(enableExpandableRows || hasObservationImageColumns() ? columns.length + 2 : columns.length)"
            class="no-data-text text-sm py-2 text-center"
          >
            No Records to Show
          </td>
        </tr>
        }
      </tbody>
      @if (footerRow) {
      <tfoot class="bg-gray-100 font-semibold text-[#25282D]">
        <tr class="border-t border-[#DBE0E6]">
          @for (column of visibleColumns; track column.key) {
          <td
            class="py-[10px] px-4 text-sm whitespace-nowrap"
            [ngClass]="{
              'text-center':
                column.key === 'status' ||
                column.key === 'result' ||
                column.key === 'registerStatus' ||
                column.key === 'availability' ||
                column.key === 'loanStatus' ||
                column.key === 'lastAuditStatus' ||
                column.key === 'packet' ||
                column.key === 'queryStatus' ||
                column.key === 'currentStatus' ||
                column.key === 'picView' ||
                column.key === 'videoView' ||
                column.key === 'action' ||
                column.key === 'statusAction' ||
                column.key === 'actions' ||
                column.key === 'response' ||
                column.key === 'items',
              'text-left':
                column.key !== 'status' &&
                column.key !== 'result' &&
                column.key !== 'registerStatus' &&
                column.key !== 'availability' &&
                column.key !== 'loanStatus' &&
                column.key !== 'lastAuditStatus' &&
                column.key !== 'packet' &&
                column.key !== 'queryStatus' &&
                column.key !== 'currentStatus' &&
                column.key !== 'picView' &&
                column.key !== 'videoView' &&
                column.key !== 'action' &&
                column.key !== 'statusAction' &&
                column.key !== 'response' &&
                column.key !== 'items' &&
                column.key !== 'menu',
              'text-right': column.key === 'menu' || column.key === 'expand',
              'hidden md:table-cell': isSecurityStatusTable
            }"
          >
            {{ getCellDisplayValue(footerRow, column) }}
          </td>
          }
          @if (enableExpandableRows || hasObservationImageColumns()) {
          <td class="py-[10px] px-4 text-sm"></td>
          }
        </tr>
      </tfoot>
      }
    </table>
  </div>
</div>

<!-- Custom Tooltip (positioned outside table container) -->
@if (tooltipVisible && tooltipText) {
  <div
    class="custom-tooltip"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY"
  >
    {{ tooltipText }}
  </div>
}

<!-- Camera Capture Modal -->
<app-camera-capture-modal
  (imageCaptured)="onCameraImageCaptured($event)"
  (cancelled)="onCameraCancelled()"
></app-camera-capture-modal>
